

// New version of ExpertGrid that uses API results and populates different sections dynamically
export class ExpertGrid {
  constructor() {
    this.apiEndpoint = "/wp-json/ortho-tennessee/v1/physicians";

    this.newDescription = document.getElementById("new-description");
    this.parentGrid = document.getElementById("expert-grid-parent");
    this.subSpecialtySection = document.getElementById("sub-specialty-section");
    this.secondaryGrid = document.getElementById("offering-grid");
    this.secondaryTitle = document.getElementById("offering-specialty-name");

    this.spineSurgeryGrid = document.getElementById("spine-surgery-grid");
    this.spineNonSurgeryGrid = document.getElementById("spine-nonsurgery-grid");
    this.sportsSurgeryGrid = document.getElementById("sports-surgery-grid");
    this.sportsNonSurgeryGrid = document.getElementById("sports-nonsurgery-grid");
    const urlParams = new URLSearchParams(window.location.search);


    this.filters = {
      specialty: urlParams.get("specialty") || '',
      location: urlParams.get("location") || '',
      title: urlParams.get("title") || ''
    };

    // Sync UI dropdowns and search with URL params
document.querySelectorAll(".expert-filter").forEach((el) => {
  const key = el.dataset.filterGroup;
  const value = this.filters[key];
 
  if (value) {
    el.value = value;

    if (key === "specialty") {
      const footHeader = document.querySelector('h3[id^="foot-and-ankle-specialists"]');
      if (footHeader) {
        footHeader.style.display = value === "footankle" ? "block" : "none";
      }
    }
  }
});

const searchBox = document.querySelector(".expert-filter-search-box");
if (this.filters.title) {
  searchBox.value = this.filters.title;
}

        this.services = {
      "footankle": {
        "description": "The foot and ankle are the body’s foundation. We have foot and ankle experts who understand the intricate and complex structures and treat conditions ranging from sprains and fractures to more complex issues that require reconstructive surgical care."
      },
      "generalorthopaedics": {
        "description": "Orthopaedics focuses on injuries and diseases of the bones, joints, nerves and muscles and a supporting cast of connectors that help your body move. Our physicians and advanced practitioners offer a superior quality of diagnostic proficiency and, if needed, an unmatched level of surgical expertise for your orthopaedic issues."
      },
      "handwrist": {
        "description": "Our hand and wrist specialists can treat your condition with expertise and care. We treat a spectrum of hand problems, from old or new trauma or injuries, arthritic conditions, congenital abnormalities, nerve compression disorders such as carpal tunnel syndrome, abnormal growths and more."
      },
      "hipknee": {
        "description": "You depend on the joints in your hips to work properly and painlessly. Our hip specialists can provide non-surgical treatment of hip issues such as therapy, exercise and medication, as well as surgery options such as hip replacement when routine activities become impossible. Our joint replacement specialists can help restore you to an active and pain-free lifestyle with minimal invasion and optimal care."
      },
      "oncology": {
        "description": "Orthopaedic oncology is a specialized field of medicine involving the evaluation, diagnosis and treatment of tumors and cancers that affect the body’s bones, cartilage, fibrous tissues, muscles, nervous tissues, soft tissues and vessels. Our specialists can treat these tumors and cancers including sarcomas and metastatic bone disease."
      },
      "pediatric": {
        "description": "From growing pains to playground injuries, children have unique needs when it comes to orthopaedic care. Our pediatric orthopaedic specialists understand the particular demands of treating children and the many complexities of your child’s bone and joint problems."
      },
      "spineneckback": {
        "description": "The spine functions as your foundation for mobility and strength. It also protects the vital lines of the body’s internal communication: the nerves and spinal cord. Our caring and experienced back and neck specialists can perform delicate and complex spinal surgery or provide non-operative treatment, including comprehensive therapy and rehabilitation programs. Many orthopaedic problems can be relieved without surgery. We emphasize holistic care as we strive to minimize medication and maximize rehabilitative approaches."
      },
      "sportsmedicine": {
        "description": "Our fellowship-trained sports medicine specialists possess the advanced level of experience and expertise to best treat sports injuries from the common to the complex. Athletes of all ages and skill levels have returned to their sports safely, with a renewed confidence in their ability to compete. Our team of orthopaedic specialists is on hand to provide you with the most comprehensive care available and an unmatched level of experience and expertise."
      },
      "trauma": {
        "description": "Traumatic injuries to the musculoskeletal system are unique and require immediate care and treatment. Our orthopaedic trauma specialists have extensive experience in caring for patients with complicated traumatic injuries affecting the body’s bones, joints, muscles and ligaments stemming from accidents, falls, sports or other high-impact incidents."
      }
    };

    this.bindEvents();
    this.loadExperts();

    this.specialtyLabels = {
      footankle: "Foot & Ankle procedures",
      generalorthopaedics: "General Orthopaedics procedures",
      handwrist: "Hand & Wrist procedures",
      hipknee: "Hip & Knee procedures",
      pediatric: "Pediatric procedures",
      shoulder: "Shoulder procedures",
      trauma: "Trauma procedures"
    };

   
    
  }

  bindEvents() {
    const selects = document.querySelectorAll(".expert-filter");
    selects.forEach(select => {
      select.addEventListener("change", (e) => {
        const key = e.target.dataset.filterGroup;
        this.filters[key] = e.target.value;

        if (key === "specialty") {
          const footHeader = document.querySelector('h3[id^="foot-and-ankle-specialists"]');
          if (footHeader) {
            footHeader.style.display = e.target.value === "footankle" ? "block" : "none";
          }
        }
      
        this.loadExperts();
      });
    });

    const searchBox = document.querySelector(".expert-filter-search-box");
    searchBox.addEventListener("keyup", this.debounce((e) => {
      this.filters.title = e.target.value;
      this.loadExperts();
    }, 500));
  }

  async loadExperts() {
    const loader = document.getElementById("expert-loader");

    loader.style.display = "flex"; // 👈 Show the spinner

    const params = new URLSearchParams(this.filters).toString();
    const response = await fetch(`${this.apiEndpoint}?${params}`);
    const data = await response.json();

    this.clearGrids();
    this.updateSpecialtyDescription(); // 🟩 Re-add this to show the correct text

    this.renderExperts(data.experts);
    this.renderSubSpecialtyExperts(data.subspecialty_experts);
    this.renderSecondaryExperts(data.secondary_experts);
    loader.style.display = "none"; // 👈 Hide the spinner when done

  }

  clearGrids() {
    this.parentGrid.innerHTML = '';
    this.subSpecialtySection.innerHTML = '';
    this.secondaryGrid.innerHTML = '';
    this.spineSurgeryGrid.innerHTML = '';
    this.spineNonSurgeryGrid.innerHTML = '';
    this.sportsSurgeryGrid.innerHTML = '';
    this.sportsNonSurgeryGrid.innerHTML = '';

    document.getElementById("spine-surgery-section").style.display = 'none';
    document.getElementById("spine-nonsurgery-section").style.display = 'none';
    document.getElementById("sports-surgery-section").style.display = 'none';
    document.getElementById("sports-nonsurgery-section").style.display = 'none';
    document.getElementById("offering-section").style.display = 'none';
  }

  renderExperts(experts) {
    if (!experts || !experts.length) return;

    const specialty = this.filters.specialty;

    experts.forEach(expert => {
      const card = this.createExpertCard(expert);
      if (specialty === 'spineneckback') {
        const target = expert.is_surgeon === 'yes' ? this.spineSurgeryGrid : this.spineNonSurgeryGrid;
        target.appendChild(card);
        document.getElementById(expert.is_surgeon === 'yes' ? "spine-surgery-section" : "spine-nonsurgery-section").style.display = 'block';
      } else if (specialty === 'sportsmedicine') {
        const target = expert.is_surgeon === 'yes' ? this.sportsSurgeryGrid : this.sportsNonSurgeryGrid;
        target.appendChild(card);
        document.getElementById(expert.is_surgeon === 'yes' ? "sports-surgery-section" : "sports-nonsurgery-section").style.display = 'block';
      } else {
        this.parentGrid.appendChild(card);
      }
    });
  }

  renderSubSpecialtyExperts(groups) {
    if (!groups || Object.keys(groups).length === 0) return;
    this.subSpecialtySection.style.display = 'block';

    Object.entries(groups).forEach(([key, experts]) => {
      const block = document.createElement('div');
      block.id = `sub-specialty-${key}`;
      block.classList.add('expert-subgrid');

      const title = document.createElement('h3');
      title.id = `sub-specialty-title-${key}`;
      title.textContent = `${this.capitalize(key)}`;
      block.appendChild(title);

      const grid = document.createElement('div');
      grid.classList.add('expert-grid');
      grid.id = `sub-specialty-grid-${key}`;

      experts.forEach(expert => grid.appendChild(this.createExpertCard(expert)));
      block.appendChild(grid);
      this.subSpecialtySection.appendChild(block);
    });
  }

  renderSecondaryExperts(experts) {
    if (!experts || !experts.length) return;
    this.secondaryGrid.innerHTML = '';
    this.secondaryTitle.textContent =
    this.specialtyLabels[this.filters.specialty] ||
    this.capitalize(this.filters.specialty.replace(/_/g, ' ')) + ' procedures';
    document.getElementById("offering-section").style.display = 'block';

    experts.forEach(expert => this.secondaryGrid.appendChild(this.createExpertCard(expert)));
  }

  createExpertCard(expert) {
    const card = document.createElement('div');
    card.classList.add('expert-card');
    card.innerHTML = `
      <a href="${expert.link}">
        ${expert.headshot ? `<img src="${expert.headshot}" alt="${expert.name}" />` : ''}
        <div class="expert-grid-title">
        ${expert.name}
         <br />
        ${expert.title}
        </div>
      </a>
    `;
    return card;
  }

  debounce(func, delay) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(this, args), delay);
    };
  }

  capitalize(word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }


  updateSpecialtyDescription() {
    if (!this.newDescription) return;
  
    const selected = this.filters.specialty || '';
    const service = this.services[selected];
  
    this.newDescription.innerHTML = '';
  
    if (selected === 'all' || !service) return;
  
    const paragraph = document.createElement('p');
    paragraph.textContent = service.description;
    this.newDescription.appendChild(paragraph);
  }
}

